// 字段名称常量
export const FIELD_NAMES = {
  responsible: 'responsible',
  technicalSupportAccidentLevel: 'technicalSupportAccidentLevel',
  accidentAddress: 'accidentAddress',
  technicalSupportDescription: 'technicalSupportDescription',
  accidentTime: 'accidentTime',
  technicalSupportAttmentList: 'technicalSupportAttmentList',
} as const;

// 简化的字段配置
export const FORM_FIELD_CONFIG = {
  responsible: {
    label: '有无责任',
    placeholder: '请选择有无责任',
  },
  technicalSupportAccidentLevel: {
    label: '事故等级',
    placeholder: '请选择事故等级',
  },
  accidentAddress: {
    label: '发生位置',
    placeholder: '请输入详细位置',
  },
  technicalSupportDescription: {
    label: '问题描述',
    placeholder: '请输入事故描述',
    maxLength: 200,
  },
  accidentTime: {
    label: '事故发生时间',
    placeholder: '请选择时间',
  },
  technicalSupportAttmentList: {
    label: '补充凭证',
    max: 3,
    actionUrl: `${location.protocol}//${process.env.JDX_APP_FETCH_DATA_DOMAIN}/monitor/web/common/fileUpload`,
  },
};

// 验证上下文类型
export type ValidationCtx = {
  fileUploading: boolean;
  vehicleName?: string;
  formInstance?: any;
};

// trim 验证器 - 用于 ant-design Form 的 rules 配置
export const trimValidator = (fieldLabel: string) => ({
  validator: (_: any, value: any) => {
    if (!value || String(value).trim() === '') {
      return Promise.reject(new Error(`请输入${fieldLabel}`));
    }
    return Promise.resolve();
  },
});

type WhenPredicate = (ctx: ValidationCtx) => boolean;

/**
 * 事故单的校验条件与提示信息的映射关系
 */
export const ValidationMap: { when: WhenPredicate; message: string }[] = [
  {
    when: (ctx: ValidationCtx) => ctx.fileUploading,
    message: '存在上传中的文件，请上传完毕后操作！',
  },
  {
    when: (ctx: ValidationCtx) => !ctx.vehicleName || !ctx.formInstance,
    message: '数据异常，请退出重试！',
  },
  {
    when: (ctx: ValidationCtx) =>
      (ctx.formInstance?.getFieldValue('accidentAddress') ?? '')
        .toString()
        .trim() === '',
    message: '请输入发生位置',
  },
  {
    when: (ctx: ValidationCtx) =>
      (ctx.formInstance?.getFieldValue('technicalSupportDescription') ?? '')
        .toString()
        .trim() === '',
    message: '请输入问题描述',
  },
];
